import React from "react";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import { LmsDocuSignSenderReceiverOptions } from "../../constants/GlobalConstants";

const addDocuSignSenderReceiverFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([myForm.getDropdownField("DocuSign Document", "metadata/list-docusign-document-masters", { name: "docuSignDocumentMasterId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Contact Type", LmsDocuSignSenderReceiverOptions, { name: "contactTypeOption", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Business Role", "metadata/list-business-roles", { required: true })]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Is Active", { inline: true })]) ;
  return myForm;
};

const AddDocuSignSenderReceiver = () => {
  const initialData = {
    isActive: true,
  };

  const myForm = addDocuSignSenderReceiverFields(new BCFormController(initialData, { submitSuffix: "document/docusign-sender-receiver" }));
  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions}  />;
};

const EditDocuSignSenderReceiver = ({ id, history }) => {
  if (FeatureFlags.IS_DEBUG) {
     console.log(id);
  }
  
  const handleClose = () => {
    history.replace("/documents-docusign-sender-receiver");
  };

  const [{ data = {}, isLoading, error }] = useFetchData(`document/docusign-sender-receiver/${id}`, {  skipCache: true});
  const myForm = addDocuSignSenderReceiverFields(new BCFormController(data, { submitSuffix: "document/docusign-sender-receiver" }));
  const formActions = ["save", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} error={error} isLoading={isLoading} actions={formActions} handleClose={handleClose} />;
};

const DocuSignSenderReceiverTable = () => {
  return <LmsTable
    actionButtons={["add", "edit", "export"]}
    apiSuffix="document/docusign-sender-receivers"
    columnLabelsDictionary={{ docuSignDocumentMaster: "DocuSign Document", contactTypeOption: "Contact Type" }}
  />;
};

const LmsDocuSignSenderReceiver = ({ ...props }) => {
  const { params = {}, history } = props;
  const allowedActions = ["add", "edit"];
  const { isAdd, isEdit, id, isMainPage, isActionAllowed } = useParseRouteActions(params, allowedActions);

  if (!isActionAllowed) {
    history.goBack();
  }

  return <React.Fragment>
    {isMainPage && <DocuSignSenderReceiverTable />}
    {isAdd && <AddDocuSignSenderReceiver />}
    {isEdit && <EditDocuSignSenderReceiver id={id} history={history} />}
  </React.Fragment>;
};

export default LmsDocuSignSenderReceiver;